import React, { ReactNode } from 'react';

import { CenterProps, Flex, HStack, Box, StackProps } from '@chakra-ui/react';
import { colorOpacity } from 'theme';

import { CustomTooltip } from 'components/DataDisplay/Tooltip/CustomTooltip';
import { AriksaIcon } from 'components/Icons/Components';
import { getIconColor } from 'components/Icons/Components/getIconColor';
import { IconSize, IconType } from 'components/Icons/types';

export interface WithResourceIconProps {
  resourceType?: IconType;
  defaultIcon?: ReactNode;
  icon?: ReactNode;
  //bgColor?: string;
  color?: string;
  children: ReactNode;
  iconSize?: IconSize;
  iconFilled?: boolean;
  iconTooltip?: ReactNode;
  spacing?: number;
  iconStyles?: CenterProps;
  tooltip?: ReactNode;
  useCustomColor?: boolean;
  border?: boolean;
  hStackStyles?: StackProps;
}

export const WithResourceIcon = (props: WithResourceIconProps) => {
  const {
    resourceType,
    children,
    //bgColor,
    iconSize = 'sm',
    iconTooltip,
    spacing = 3,
    iconStyles,
    tooltip,
    color,
    border = false,
    hStackStyles,
    ...rest
  } = props;

  const iconColor = getIconColor(resourceType as string);

  const renderIcon = () => (
    <AriksaIcon
      type={resourceType}
      bg={colorOpacity(color ?? iconColor, 0.2)}
      size={iconSize}
      style={iconStyles}
      color={color ?? iconColor}
      border={border}
      borderColor={color ?? iconColor}
      useCustomColor
      {...rest}
    />
  );

  const renderChildren = () => (
    <Box w="full" overflow="hidden" textOverflow="ellipsis">
      {children}
    </Box>
  );

  return (
    <HStack spacing={spacing} w="full" {...hStackStyles}>
      <Flex>
        {iconTooltip ? (
          <CustomTooltip label={iconTooltip}>{renderIcon()}</CustomTooltip>
        ) : (
          renderIcon()
        )}
      </Flex>
      {tooltip ? (
        <CustomTooltip label={tooltip}>{renderChildren()}</CustomTooltip>
      ) : (
        renderChildren()
      )}
    </HStack>
  );
};

export const renderIconWithLabel = (iconType, label, iconColor = 'primary') => {
  return (
    <WithResourceIcon
      resourceType={iconType}
      color={iconColor}
      iconFilled={false}
      iconStyles={{ w: 5, h: 5 }}
    >
      <Box textAlign="left">{label}</Box>
    </WithResourceIcon>
  );
};
